"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.instrumentPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var instrumentPropType = exports.instrumentPropType = _propTypes["default"].shape({
  OMSId: _propTypes["default"].number.isRequired,
  InstrumentId: _propTypes["default"].number.isRequired,
  Symbol: _propTypes["default"].string.isRequired,
  Product1: _propTypes["default"].number.isRequired,
  Product1Symbol: _propTypes["default"].string.isRequired,
  Product2: _propTypes["default"].number.isRequired,
  Product2Symbol: _propTypes["default"].string.isRequired,
  InstrumentType: _propTypes["default"].string.isRequired,
  VenueInstrumentId: _propTypes["default"].number.isRequired,
  VenueId: _propTypes["default"].number.isRequired,
  SortIndex: _propTypes["default"].number.isRequired,
  SessionStatus: _propTypes["default"].string.isRequired,
  PreviousSessionStatus: _propTypes["default"].string.isRequired,
  SessionStatusDateTime: _propTypes["default"].string.isRequired,
  SelfTradePrevention: _propTypes["default"].bool.isRequired,
  QuantityIncrement: _propTypes["default"].number.isRequired
});